import Vue from 'vue'
import routerMethod from './method/routerMethod'
import {
  mainHeightComputed,
  tableHeightComputed,
} from './method/heightComputedMethod'
import {
  heightConfig,
  tablePageConfig,
  placeholderConfig,
  messageConfig,
} from './params/global.js'
import {
  validNumerical
} from './params/global.js'
import {
  removeObjectNull,
  removeEmptyForTable,
  removeArrayNull,
  ykDateFormat,
} from './utils/globalFunc.js'
import authorityMethods from '@/public/method/AuthoryMethod'
import tableMethods from '@/public/method/tableMethods'
import {
  validateIP,
  validatePhoneTwo,
  validateTelphone,
  validatePhone,
  validateIdNo,
  validateEMail,
  isPercentZeroToHundred,
  validateURL,
  isPassword,
  isInteger,
  isDecimal,
  isNaturalNumber,
  validateNumber,
  validateDateTime,
  validateDateTimeNoEmpty,
} from '@/public/method/validFun.js'
import {
  VDate,
  VDatetime
} from './method/directive'
import {
  debounce
} from './utils/performance.js'
import {
  ykImportFormat
} from './method/FormatMethod.js'
// 变量
Vue.prototype.tablePageConfig = tablePageConfig
Vue.prototype.heightConfig = heightConfig
Vue.prototype.placeholderConfig = placeholderConfig
Vue.prototype.messageConfig = messageConfig
Vue.prototype.validNumerical = validNumerical
// 方法
Vue.prototype.openPath = (path) => routerMethod.openPath(path)
Vue.prototype.mainHeightComputed = (subVal) => mainHeightComputed(subVal)
Vue.prototype.tableHeightComputed = (customHeight, isSearchForm, isToolBar) =>
  tableHeightComputed(customHeight, isSearchForm, isToolBar)
Vue.prototype.removeObjectNull = (obj) => removeObjectNull(obj)
Vue.prototype.removeArrayNull = (obj) => removeArrayNull(obj)

Vue.prototype.ykImportFormat = (fmt, str) => ykImportFormat(fmt, str) // 导入日期转换为字符串
Vue.prototype.ykDateFormat = (fmt, str) => ykDateFormat(fmt, str)
Vue.prototype.removeEmptyForTable = (table, defaultArray) =>
  removeEmptyForTable(table, defaultArray)

// vxe-table方法
Vue.prototype.removeEmptyForTable = (table, defaultArray) =>
  tableMethods.removeEmptyForTable(table, defaultArray)
Vue.prototype.repeatForTable = (errIndex, table, defaultArray) =>
  tableMethods.repeatForTable(errIndex, table, defaultArray)
Vue.prototype.removeRowForTable = (row, table, IfExistModify) =>
  tableMethods.removeRowForTable(row, table, IfExistModify)
// Vue.prototype.tableSelectTotal = a => tableMethods.tableSelectTotal(a)
// Vue.prototype.megerArea = areas => tableMethods.megerArea(areas)

// 权限过滤
Vue.prototype.AuthorityFilter = (path) => authorityMethods.AuthorityFilter(path)

// 校验方法
// 校验方法
Vue.prototype.validateIP = (rule, value) => validateIP(rule, value)
Vue.prototype.validatePhoneTwo = (rule, value) => validatePhoneTwo(rule, value)
Vue.prototype.validateTelphone = (rule, value) => validateTelphone(rule, value)
Vue.prototype.validatePhone = (rule, value) => validatePhone(rule, value)
Vue.prototype.validateIdNo = (rule, value) => validateIdNo(rule, value)
Vue.prototype.validateEMail = (rule, value) => validateEMail(rule, value)
Vue.prototype.validateURL = (textval) => validateURL(textval)
Vue.prototype.isPassword = (rule, value) => isPassword(rule, value)
Vue.prototype.isInteger = (rule, value) => isInteger(rule, value)
Vue.prototype.isDecimal = (rule, value) => isDecimal(rule, value)
Vue.prototype.isNaturalNumber = (rule, value) => isNaturalNumber(rule, value)
Vue.prototype.isPercentZeroToHundred = (rule, value) =>
  isPercentZeroToHundred(rule, value)
Vue.prototype.validateNumber = (rule, value) => validateNumber(rule, value)
Vue.prototype.validateDateTime = (rule, value) => validateDateTime(rule, value)
Vue.prototype.validateDateTimeNoEmpty = (rule, value) =>
  validateDateTimeNoEmpty(rule, value)

// 防抖
Vue.prototype.debounce = (fn, delay) => debounce(fn, delay)

// 自定义指令
Vue.directive('date', VDate)
Vue.directive('datetime', VDatetime)